import React from 'react';
import { Button } from 'antd';

import { BaseImageProps, Image } from 'app/components/common/image';
import { ResponsiveTypography } from 'app/components/common/typography';
import { Typography } from 'app/components/domain/typography';
import { i18n } from 'app/i18n';
import { BREAKPOINTS } from 'app/styles/breakpoints';

import styles from './switch-link.module.scss';

interface Props {
    icon: BaseImageProps;
    title: string;
    text: string;
    onClick: () => void;
}

const SwitchLink: React.FC<Props> = (props) => {
    const { icon, title, text, onClick } = props;

    return (
        <div className={styles.switchLinkContainer}>
            <div className={styles.iconContainer}>
                <Image className={styles.image} {...icon} />
            </div>
            <div className={styles.textContainer}>
                <ResponsiveTypography
                    className={styles.title}
                    rules={{
                        [BREAKPOINTS.MOBILE]: {
                            subtitle3: 'body2',
                        },
                    }}
                    variant="subtitle3"
                    component="p"
                >
                    {title}
                </ResponsiveTypography>
                <Typography variant="body2" component="p">
                    {text}
                </Typography>
            </div>
            <Button onClick={onClick} type="default">
                {i18n.components.switchLink.change}
            </Button>
        </div>
    );
};

export { SwitchLink };
